import React from 'react';
import PropTypes from 'prop-types';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import { green, amber } from '@mui/material/colors';
import {styled} from '@mui/system';


const StyledSuccessSnackbarContent = styled(SnackbarContent)({
    backgroundColor: green[600]
});

const StyledInfoSnackbarContent = styled(SnackbarContent)(({ theme }) =>({
    backgroundColor: theme.palette.primary.dark
}));

const StyledWarningSnackbarContent = styled(SnackbarContent)({
    backgroundColor: amber[700]
});

const StyledErrorSnackbarContent = styled(SnackbarContent)(({ theme }) =>({
    backgroundColor: theme.palette.error.dark
}));

const snackbarContentVariants = {
    success: StyledSuccessSnackbarContent,
    info: StyledInfoSnackbarContent,
    warning: StyledWarningSnackbarContent,
    error: StyledErrorSnackbarContent
};

const StyledSuccessIcon = styled(CheckCircleIcon)(({ theme }) =>({
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.custom.spacing.default,
}));

const StyledInfoIcon = styled(InfoIcon)(({ theme }) =>({
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.custom.spacing.default,
}));

const StyledWarningIcon = styled(WarningIcon)(({ theme }) =>({
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.custom.spacing.default,
}));

const StyledErrorIcon = styled(ErrorIcon)(({ theme }) =>({
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.custom.spacing.default,
}));

const iconVariants = {
    success: StyledSuccessIcon,
    info: StyledInfoIcon,
    warning: StyledWarningIcon,
    error: StyledErrorIcon
};

const StyledIcon = styled(CloseIcon)({
    fontSize: 20
});

const StyledMessage = styled('span')({
    display: 'flex',
    alignItems: 'center'
});


class Message extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            is_open : true,
        };

    }

    manageCallBack(){
        if(this.props.closeCallBack){
            this.props.closeCallBack();
        }
    }

    onClose = () =>{
        this.setState({is_open: false}, this.manageCallBack);
    };

    render() {
        const {message} = this.props;
        const Icon = iconVariants[this.props.variant];
        const SnackbarContentComponent = snackbarContentVariants[this.props.variant];
        const optional_attributes = {};

         if(this.props.dataBt){
            optional_attributes["data-bt"] = this.props.dataBt;
        }
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={this.state.is_open}
                autoHideDuration={this.props.autoHideDuration || null}
                onClose={this.onClose}
                data-bt="system_message"
            >
                <SnackbarContentComponent
                    aria-describedby="client-snackbar"
                    message={
                        <StyledMessage id="client-snackbar" {...optional_attributes}>
                            <Icon />
                            {message}
                        </StyledMessage>
                    }
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={this.onClose}
                            size="large">
                            <StyledIcon />
                        </IconButton>
                    ]}
                />
            </Snackbar>
        );
    }

}


Message.propTypes = {
    closeCallBack: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'info', 'warning', 'error']).isRequired,
    message: PropTypes.string,
    autoHideDuration: PropTypes.number,
    dataBt: PropTypes.string
};


export default Message;
